<template>
    <div class="wrap">
        <div class="searchBox">
            <img src="../assets/search.png" alt="">
            <input @input="iptChange"/>
            <div class="searchList">
                <div v-for="(item,index) in searchList" :key="index" @click="changeCity(item.city)">{{item.city}}</div>
            </div>
        </div>
        <div class="tit">热门城市</div>
        <div class="hotCityBox">
            <div class="cityBox" v-for="(item,index) in hotCity" :key="index" @click="changeCity(item)">{{item}}</div>
            
        </div>
        <!-- <div> -->
            <div v-for="(item,index) in cityInfoList" :key="index" class="cityListWrap">
                <div class="tit">{{item.word}}</div>
                <div v-for="(items,ind) in item.list" :key="ind" class="city" @click="changeCity(items.city)">{{items.city}}</div>
            </div>

            <div class="wordList">
                <p v-for="(item,index) in cityInfoList" :key="index" @click="goTop(item.word,index)">
                    {{item.word}}
                </p>
            </div>
        <!-- </div> -->
    </div>
</template>
<script>
import store from '../utils/store'
export default {
    data (){
        return {
            word:['A','B','C'],
            store,
            words:[],
            cityInfoList:[{}],
            hotCity:[
                '北京',
                '上海',
                '深圳',
                '成都',
                '杭州',
                '青岛',
                '南通',
                '广州',
                '贵阳',
                '郑州',
                '海口',
                '太原'
            ],
            allCityInfo:[],
            searchList:[]
        }
    },
    mounted (){
        let wordList = [];
        for(var i=0;i<26;i++){
            wordList.push(String.fromCharCode(65+i))
        }
        
        let storeWords = [];
        for(let i = 0;i<this.store.length;i++){
            storeWords.push(this.store[i].word)
        }
        let words = words;
        //城市首字母
        words = Array.from(new Set(storeWords)).sort();


        let obj = {}
        //所有城市
        let peon = store.reduce((cur,next) => {
            obj[next.city] ? "" : obj[next.city] = true && cur.push(next);
            return cur;
        },[])
        this.allCityInfo = peon;
        
        // let cityInfo = []
        let cityInfoList = []
        for(let i = 0;i<words.length;i++){
            let obj = {};
            obj.word = words[i];
            obj.list = peon.filter(e => {
                return e.word == words[i]
            })
            cityInfoList.push(obj)
        }


        

        this.cityInfoList = cityInfoList;

        let e = document.getElementsByClassName('cityListWrap')[0].offsetTop
        console.log(e)

        document.getElementsByClassName('wordList')[0].style.top = e +'px';


    },
    methods:{
        goTop (word,ind){
            console.log(word)
            //所有字母层
            let e = document.getElementsByClassName('cityListWrap')[ind].getElementsByClassName('tit');



            console.log(e)
            let t = 0;
            for(let i = 0;i<e.length;i++){
                if(e[i].innerHTML == word){
                    console.log("11111")
                    console.log(e[i].parentNode)
                    // e[i].
                    t = e[i].parentNode.offsetTop;
                    document.documentElement.scrollTop = t;
                }
            }


            console.log(t)
        },
        changeCity (item){
            localStorage.setItem("cityName",item);
            this.$router.push('/store')
        },
        iptChange (val){
            let name = val.target.value;
            if(name!=''){
                let list = this.allCityInfo.filter(e => {
                    return e.city.indexOf(name) != '-1'
                })
                console.log(list)
                this.searchList = list;
            }else {
                this.searchList = []
            }
            
        }
    }
}
</script>
<style scoped lang="scss">
.wrap {
    padding:1rem;
    height: 100%;
    overflow-y: auto;
    background: #ffffff
}
.searchBox {
    height: 2.4rem;
    width: 100%;
    box-sizing: border-box;
    background: #E9E9E9;
    border-radius: 0.5rem;
    position: relative;
    input {
        height: 100%;
        width: 100%;
        display:block;
        box-sizing:border-box;
        padding-left:2rem;
        background: transparent;
        border:none;
    }
    img {
        position: absolute;
        width: 1rem;
        top: 50%;
        left: 0.5rem;
        transform: translateY(-50%);
    }
    .searchList {
        position: absolute;
        top: 2.4rem;
        left: 0;
        background: #ffffff;
        
        width: 100%;
        div {
            height: 2rem;
            line-height: 2rem;
            text-align: left;
        }
    }
}
.tit {
    height: 2rem;
    line-height: 2rem;
    font-size: 0.8rem;
    color: #9D9D9D;
    text-align: left;
    margin-top: 1rem;
}
.hotCityBox {
    margin-top: 1rem;
    overflow: hidden;
    .cityBox {
        height: 2.4rem;
        line-height: 2.4rem;
        width: 4rem;
        border: 1px solid #565656;
        border-radius: 0.5rem;
        margin-right: 1rem;
        float: left;
        margin-bottom: 1rem;
    }
}
.cityListWrap {
    text-align: left;
    position: relative;
    .city {
        height: 2.4rem;
        line-height: 2.4rem;
        color: #565656;
    }
    
}
.wordList {
        position: fixed;
        right: 0;
        
        font-size: 0.4rem;
        margin: 0.5rem;
    }
</style>